import React from "react";
import { getMessage } from "../../../utils/getMessage";

export const Footer = ({ showDate, showCopyRight, msg, img1, img2, alt1, alt2 }) => {
  return (
    <div className="footer">
      <div>
        {img1 && <img src={`${img1}`} alt={{ alt1 }} />}
        {img2 && <img src={`${img2}`} alt={{ alt2 }} />}
        {msg && <p className="footer-message">{msg}</p>}
      </div>
      <div>
        {showDate && <p>@{new Date().getFullYear()} - derechos reservados</p>}
        {showCopyRight && <p>{getMessage(20)}</p>}
        <small className="version">{`V ${process.env.REACT_APP_VERSION}`}</small>
      </div>
    </div>
  );
};
